import service from "./service.js"
import auth from "./auth.js"
export default {
    service,auth
}